// /srv/docker/develop/strike.hu_51200-51220/next/lib/localizedRoutes.js

export const SITE_URL =
    "https://www.strike.hu";

export const ROUTES = [
    {
        key:
            "home",

        label: {
            hu:
                "mi a strike?",

            en:
                "what is strike?",
        },

        paths: {
            hu:
                "/",

            en:
                "/en",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                true,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                1,
        },
    },

    {
        key:
            "strike-zone",

        label: {
            hu:
                "strike zone",

            en:
                "strike zone",
        },

        paths: {
            hu:
                "/strike-zone",

            en:
                "/en/strike-zone",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.9,
        },
    },

    {
        key:
            "feed-the-beast",

        label: {
            hu:
                "feed the beast",

            en:
                "feed the beast",
        },

        paths: {
            hu:
                "/feed-the-beast",

            en:
                "/en/feed-the-beast",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                true,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.8,
        },
    },

    {
        key:
            "private-room",

        label: {
            hu:
                "private room",

            en:
                "private room",
        },

        paths: {
            hu:
                "/private-room",

            en:
                "/en/private-room",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                true,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.9,
        },
    },

    {
        key:
            "prices",

        label: {
            hu:
                "árlista",

            en:
                "prices",
        },

        paths: {
            hu:
                "/arlista",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                true,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.8,
        },
    },

    {
        key:
            "gift-card",

        label: {
            hu:
                "ajándékkártya",

            en:
                "gift card",
        },

        paths: {
            hu:
                "/ajandekkartya",

            en:
                "/en/gift-card",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                true,
        },

        sitemap: {
            changeFrequency:
                "monthly",

            priority:
                0.7,
        },
    },

    {
        key:
            "booking",

        label: {
            hu:
                "foglalj most",

            en:
                "book now",
        },

        paths: {
            hu:
                "/booking",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                true,
        },

        sitemap: {
            changeFrequency:
                "daily",

            priority:
                0.9,
        },
    },

    {
        key:
            "getting-here",

        label: {
            hu:
                "megközelítés",

            en:
                "getting here",
        },

        paths: {
            hu:
                "/megkozelites",

            en:
                "/en/getting-here",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                true,
        },

        sitemap: {
            changeFrequency:
                "monthly",

            priority:
                0.7,
        },
    },

    {
        key:
            "house-rules",

        label: {
            hu:
                "házirend",

            en:
                "house rules",
        },

        paths: {
            hu:
                "/hazirend",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "monthly",

            priority:
                0.5,
        },
    },

    {
        key:
            "faq",

        label: {
            hu:
                "gyik",

            en:
                "faq",
        },

        paths: {
            hu:
                "/gyik",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "monthly",

            priority:
                0.7,
        },
    },

    {
        key:
            "terms",

        label: {
            hu:
                "ászf",

            en:
                "terms & conditions",
        },

        paths: {
            hu:
                "/aszf",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "monthly",

            priority:
                0.3,
        },
    },

    {
        key:
            "privacy",

        label: {
            hu:
                "adatkezelési tájékoztató",

            en:
                "privacy notice",
        },

        paths: {
            hu:
                "/adatkezelesi-tajekoztato",
        },

        menu: {
            showInHeader:
                true,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "monthly",

            priority:
                0.3,
        },
    },

    {
        key:
            "indoor-activities",

        paths: {
            hu:
                "/belteri-program-budapest",

            en:
                "/en/indoor-activities-budapest",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.9,
        },
    },

    {
        key:
            "birthday-party",

        paths: {
            hu:
                "/szulinap-budapest",

            en:
                "/en/birthday-party-budapest",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.9,
        },
    },

    {
        key:
            "things-to-do-with-friends",

        paths: {
            hu:
                "/program-baratokkal-budapest",

            en:
                "/en/things-to-do-with-friends-budapest",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.9,
        },
    },

    {
        key:
            "team-building",

        paths: {
            hu:
                "/csapatepites-budapest",

            en:
                "/en/team-building-budapest",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.9,
        },
    },

    {
        key:
            "darts-budapest",

        paths: {
            hu:
                "/darts-budapest",

            en:
                "/en/darts-budapest",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.9,
        },
    },

    {
        key:
            "links",

        paths: {
            hu:
                "/linkek",

            en:
                "/en/links",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "monthly",

            priority:
                0.6,
        },
    },

    {
        key:
            "private-room-booking",

        paths: {
            hu:
                "/private-room/booking",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "daily",

            priority:
                0.8,
        },
    },

    {
        key:
            "giveaway",

        paths: {
            hu:
                "/nyeremenyjatek",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.7,
        },
    },

    {
        key:
            "house-tournaments",

        paths: {
            hu:
                "/hazi-versenyek",
        },

        menu: {
            showInHeader:
                false,

            showInLinks:
                false,
        },

        sitemap: {
            changeFrequency:
                "weekly",

            priority:
                0.7,
        },
    },
];

export const LOCALIZED_ROUTE_PAIRS =
    ROUTES
        .filter(
            (route) =>
                route.paths.hu &&
                route.paths.en
        )
        .map(
            (route) => ({
                hu:
                    route.paths.hu,

                en:
                    route.paths.en,

                sitemap:
                    route.sitemap,
            })
        );

export const NON_LOCALIZED_ROUTES =
    ROUTES
        .filter(
            (route) =>
                route.paths.hu &&
                !route.paths.en
        )
        .map(
            (route) => ({
                path:
                    route.paths.hu,

                sitemap:
                    route.sitemap,
            })
        );

function normalizePathname(
    pathname
) {
    if (
        !pathname ||
        pathname === "/"
    ) {
        return "/";
    }

    return pathname.replace(
        /\/+$/,
        ""
    );
}

export function getRouteLanguage(
    pathname
) {
    const normalizedPathname =
        normalizePathname(
            pathname
        );

    for (
        const route
        of ROUTES
    ) {
        if (!route.paths.en) {
            continue;
        }

        if (
            normalizePathname(
                route.paths.hu
            ) ===
            normalizedPathname
        ) {
            return "hu";
        }

        if (
            normalizePathname(
                route.paths.en
            ) ===
            normalizedPathname
        ) {
            return "en";
        }
    }

    return null;
}

export function getLocalizedPath(
    pathname,
    language
) {
    const normalizedPathname =
        normalizePathname(
            pathname
        );

    for (
        const route
        of ROUTES
    ) {
        const normalizedHungarianPath =
            normalizePathname(
                route.paths.hu
            );

        const normalizedEnglishPath =
            route.paths.en
                ? normalizePathname(
                    route.paths.en
                )
                : null;

        if (
            normalizedHungarianPath ===
                normalizedPathname ||
            normalizedEnglishPath ===
                normalizedPathname
        ) {
            if (
                language === "en" &&
                route.paths.en
            ) {
                return route.paths.en;
            }

            return route.paths.hu;
        }
    }

    return pathname;
}